import React from 'react';

import {useAccountManageWallet} from '../../api/hooks/useAccountManageWallet.hook';
import {useContextSsr} from '../../api/hooks/useContextSSr.hook';
import {useDigitalOriginalsPage} from '../../api/hooks/useDigitalOriginalsPage.hook';
import {useLoginPage} from '../../api/hooks/useLoginPage.hook';
import {DefaultHeader} from '../../components/_shared/header/default-header/default-header';
import {HeaderFooterWrapper} from '../../components/_shared/header-footer-wrapper/header-footer-wrapper';
import {MetaTagsResolver} from '../../components/_shared/meta-tags-resolver/meta-tags-resolver';
import ComingSoonTeaser from '../../components/digital-originals/coming-soon-teaser/coming-soon-teaser';
import {DigitalOriginalsStage} from '../../components/digital-originals/digital-originals-stage/digital-originals-stage';
import UpperFilterDigitalOriginals
    from '../../components/digital-originals/upper-filter/upper-filter-digital-originals';
import VariantsTeaser from '../../components/digital-originals/variants-teaser/variants-teaser';

const DigitalOriginals: React.FC & { dataHooks: any } = (): JSX.Element => {
    const data = useDigitalOriginalsPage();

    return (
        <HeaderFooterWrapper
            header={<DefaultHeader availableLanguages={data?.localizations} />}
            stage={
                <DigitalOriginalsStage
                    background={data?.stage?.background?.url}
                    title={data?.stage?.headline?.headlineContent ?? ''}
                    titleVariant={data?.stage?.headline?.style}
                    inverted={data?.stage?.componentStyles?.inverted ?? false}
                />
            }
        >
            <MetaTagsResolver tags={data?.meta} />
            <UpperFilterDigitalOriginals/>
            <ComingSoonTeaser />
            <VariantsTeaser />
        </HeaderFooterWrapper>
    );
};

DigitalOriginals.dataHooks = [
    useLoginPage,
    useAccountManageWallet,
    useDigitalOriginalsPage,
    useContextSsr,
    ...MetaTagsResolver.dataHooks
];

export default DigitalOriginals;
